import { useNavigate } from "react-router-dom";
import styles from "./NotFound.module.css";
import Navbar from "../Navbar/Navbar";
import WhyRexpt from "../../Components/HomePageCTA.js/HomeCta";
function NotFound({ header, isVisible }) {
  const navigate = useNavigate();
  return (

    <>
      <div className={styles.container}>
        <Navbar header={header} isVisible={isVisible} />
        <div className={styles.content}>
          <h1 className={styles.code}>404</h1>
          <h2 className={styles.title}>PAGE NOT FOUND</h2>
          <p className={styles.subtitle}>
            Oops! The page you are looking for does not exist. It might have been moved or deleted.
          </p>

          <div className={styles.cardsWrapper}>
            <div className={`${styles.card} ${styles.yellow}`} onClick={() => navigate("/features")}>
              <img src="/Svg/call-i1.svg" alt="call-i1" />
              <h3>24/7 Call Handling</h3>
              <p>Never miss a call again — we're here to answer every time.</p>
            </div>

            <div className={`${styles.card} ${styles.purple}`} onClick={() => navigate("/features")}>
              <img src="/Svg/appointment-I2.svg" alt="appointment-I2" />
              <h3>Appointment Scheduling</h3>
              <p>Let your agent book and manage appointments directly.</p>
            </div>

            <div className={`${styles.card} ${styles.pink}`} onClick={() => navigate("/features")}>
              <img src="/Svg/call-history-i3.svg" alt="call-history-i3" />
              <h3>Call History & Summaries</h3>
              <p>Get detailed call summaries sent to you.</p>
            </div>

            <div className={`${styles.card} ${styles.green}`} onClick={() => navigate("/features")}>
              <img src="/Svg/call-routing-i4.svg" alt="call-routing-i4" />
              <h3>Intelligent Call Routing</h3>
              <p>Route calls to the right person or department.</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.WhyRexptDiv}>
        <WhyRexpt />
      </div>

   
    </>
  );
}
export default NotFound;
